export default __webpack_public_path__ + "static/media/sileImg2.6b3b558d.jpg";